document.addEventListener('DOMContentLoaded', function() {
  // 获取所有hero banner组件
  const heroBanners = document.querySelectorAll('.mt-hero-banner');
  
  heroBanners.forEach(banner => {
    const useAutoHeight = banner.dataset.autoHeight === 'true';
    const disableContentFade = banner.dataset.disableContentFade === 'true';
    // 获取设置值
    const contentAlignment = banner.dataset.contentAlignment || 'center';
    const contentVertical = banner.dataset.contentVertical || 'center';
    const overlayColor = banner.dataset.overlayColor || '#000000';
    
    // 应用内容位置
    const content = banner.querySelector('.mt-hero-banner__content');
    const textContent = banner.querySelector('.mt-hero-banner__text-content');
    
    if (content) {
      // 水平对齐
      if (contentAlignment === 'left') {
        content.classList.add('mt-hero-banner__content--left');
        textContent.classList.add('mt-hero-banner__text-content--left');
      } else if (contentAlignment === 'right') {
        content.classList.add('mt-hero-banner__content--right');
        textContent.classList.add('mt-hero-banner__text-content--right');
      }
      
      // 垂直对齐
      if (contentVertical === 'top') {
        content.classList.add('mt-hero-banner__content--top');
      } else if (contentVertical === 'bottom') {
        content.classList.add('mt-hero-banner__content--bottom');
      }
    }
    
    // 应用遮罩层颜色
    const overlay = banner.querySelector('.mt-hero-banner__overlay');
    if (overlay) {
      overlay.style.backgroundColor = overlayColor;
    }
    
    // 设置banner高度
    const desktopImage = banner.querySelector('.mt-hero-banner__image--desktop');
    const mobileImage = banner.querySelector('.mt-hero-banner__image--mobile');
    const desktopVideo = banner.querySelector('.mt-hero-banner__video--desktop');
    const mobileVideo = banner.querySelector('.mt-hero-banner__video--mobile');
    
    function setBannerHeight() {
      if (useAutoHeight) {
        banner.style.height = 'auto';
        return;
      }
      if (window.innerWidth > 768) {
        // 桌面端：根据媒体比例设置高度
        if (desktopVideo) {
          // 视频元素
          const aspectRatio = desktopVideo.videoHeight / desktopVideo.videoWidth;
          const height = window.innerWidth * aspectRatio;
          banner.style.height = `${height}px`;
        } else if (desktopImage) {
          // 图片元素
          const aspectRatio = desktopImage.naturalHeight / desktopImage.naturalWidth;
          const height = window.innerWidth * aspectRatio;
          banner.style.height = `${height}px`;
        }
      } else {
        // 移动端：根据媒体比例设置高度
        if (mobileVideo) {
          // 视频元素
          const aspectRatio = mobileVideo.videoHeight / mobileVideo.videoWidth;
          const height = window.innerWidth * aspectRatio;
          banner.style.height = `${height}px`;
        } else if (mobileImage) {
          // 图片元素
          const aspectRatio = mobileImage.naturalHeight / mobileImage.naturalWidth;
          const height = window.innerWidth * aspectRatio;
          banner.style.height = `${height}px`;
        }
      }
      
      // 强制刷新遮罩层显示
      if (overlay) {
        overlay.style.display = 'none';
        overlay.offsetHeight; // 强制重排
        overlay.style.display = 'block';
      }
    }
    
    // 初始化高度
    const mediaElements = [];
    
    // 收集所有媒体元素
    if (desktopImage) mediaElements.push(desktopImage);
    if (mobileImage) mediaElements.push(mobileImage);
    if (desktopVideo) mediaElements.push(desktopVideo);
    if (mobileVideo) mediaElements.push(mobileVideo);
    
    if (mediaElements.length > 0) {
      // 等待媒体加载完成后设置高度
      Promise.all(
        mediaElements.map(element => {
          return new Promise(resolve => {
            if (element.tagName === 'VIDEO') {
              // 视频元素
              if (element.readyState >= 1) {
                resolve();
              } else {
                element.addEventListener('loadedmetadata', resolve);
              }
            } else {
              // 图片元素
              if (element.complete) {
                resolve();
              } else {
                element.addEventListener('load', resolve);
              }
            }
          });
        })
      ).then(() => {
        setBannerHeight();
      });
    } else {
      // 如果没有媒体元素，设置默认高度
      if (!useAutoHeight) banner.style.height = '600px';
    }

    // ============= 轮播功能开始 =============
    const containersWrapper = banner.querySelector('.mt-hero-banner__containers');
    const containers = banner.querySelectorAll('.mt-hero-banner__container');
    const prevBtn = banner.querySelector('.mt-hero-banner_prev');
    const nextBtn = banner.querySelector('.mt-hero-banner_next');
    
    // 初始化轮播状态
    let currentIndex = 0;
    let isAnimating = false;
    
    // 初始化轮播样式
    if (containers && containers.length > 1) {
      // 应用初始样式
     
      
      containers.forEach((container, index) => {
        
      });
      
      // 仅显示当前容器中的视频
      updateVideosVisibility();
    }
    
    // 绑定按钮事件
    if (prevBtn && containers.length > 1) {
      prevBtn.addEventListener('click', function() {
        if (!isAnimating) {
          navigateSlide('prev');
        }
      });
    }
    
    if (nextBtn && containers.length > 1) {
      nextBtn.addEventListener('click', function() {
        if (!isAnimating) {
          navigateSlide('next');
        }
      });
    }
    
    // 导航到指定方向
    function navigateSlide(direction) {
      if (isAnimating) return;
      isAnimating = true;
      
      // 计算新索引
      const oldIndex = currentIndex;
      if (direction === 'prev') {
        currentIndex = currentIndex > 0 ? currentIndex - 1 : containers.length - 1;
      } else {
        currentIndex = currentIndex < containers.length - 1 ? currentIndex + 1 : 0;
      }
      
      // 更新显示状态
      // 隐藏旧容器
      containers[oldIndex].style.opacity = '0';
      containers[oldIndex].style.zIndex = '0';
      containers[oldIndex].style.display = 'none';
      
      // 显示新容器
      containers[currentIndex].style.display = 'block';
      containers[currentIndex].style.opacity = '1';
      containers[currentIndex].style.zIndex = '1';
      
      // 更新视频播放状态
      updateVideosVisibility();
      
      // 动画结束后解锁
      setTimeout(() => {
        isAnimating = false;
      }, 500);
    }
    
    // 更新视频显示状态
    function updateVideosVisibility() {
      containers.forEach((container, index) => {
        const containerVideos = container.querySelectorAll('video');
        containerVideos.forEach(video => {
          if (index === currentIndex) {
            // 当前slide，根据是否在视口决定是否播放
            checkVideoVisibility(video, container);
          } else {
            // 不是当前slide，一律暂停
            video.pause();
            video.currentTime = 0;
          }
        });
      });
    }
    
    // 检查视频是否应该播放（基于可见性）
    function checkVideoVisibility(video, container) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            // 视频在视口中且为当前活动轮播项
            if (containers[currentIndex] === container) {
              video.play().catch(e => console.error('视频播放失败:', e));
            }
          } else {
            // 视频不在视口中，暂停播放
            video.pause();
            video.currentTime = 0;
          }
        });
      }, {
        threshold: [0.3, 0.6]
      });
      
      observer.observe(container);
    }
    
    // 自动轮播（可选功能，取消注释启用）
    /*
    let autoplayInterval;
    function startAutoplay() {
      autoplayInterval = setInterval(() => {
        if (!document.hidden) {
          navigateSlide('next');
        }
      }, 5000); // 5秒轮播间隔
    }
    
    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }
    
    // 页面可见性变化时控制自动轮播
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });
    
    // 鼠标悬停时暂停轮播
    banner.addEventListener('mouseenter', stopAutoplay);
    banner.addEventListener('mouseleave', startAutoplay);
    
    // 启动自动轮播
    startAutoplay();
    */
    // ============= 轮播功能结束 =============
    
    // 视频事件监听
    const videos = banner.querySelectorAll('video');
    
    // 视频视口检测和自动播放逻辑
    if (videos.length > 0) {
      // 记录播放状态的标志
      let isPlaying = false;
      
      // 初始暂停所有视频并设置静音和自动播放属性
      videos.forEach(video => {
        video.pause();
        video.muted = true;
        video.playsInline = true;
        video.loop = true;
        
        // 视频加载元数据后重新计算高度
        video.addEventListener('loadedmetadata', setBannerHeight);
        
        // 视频错误处理
        video.addEventListener('error', (e) => {
          console.error('视频播放错误:', e);
        });
      });
      
      // 创建Intersection Observer来监控视频是否在视口中
      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          // 获取当前banner的视频和内容元素
          const currentBanner = entry.target;
          const bannerContent = currentBanner.querySelector('.mt-hero-banner__content');
          const currentContainer = currentBanner.closest('.mt-hero-banner__container');
          
          // 确保只处理当前活动的轮播项中的视频
          if (containers.length > 1 && currentContainer !== containers[currentIndex]) {
            return;
          }
          
          const currentVideos = currentBanner.querySelectorAll('video');
          
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6 && !isPlaying) {
            // 当banner有60%进入视口时
            isPlaying = true;
            
            currentVideos.forEach(video => {
              // 播放视频
              const playPromise = video.play();
              
              if (playPromise !== undefined) {
                playPromise.then(() => {
                  // 视频成功播放，不需要淡出文字时保持可见
                  if (bannerContent && !disableContentFade) {
                    bannerContent.classList.add('fade-out');
                    bannerContent.style.transition = 'opacity 1.3s ease-out';
                    setTimeout(() => {
                      bannerContent.style.opacity = '1';
                    }, 50);
                  }
                }).catch(error => {
                  console.error('视频自动播放失败:', error);
                  isPlaying = false;
                });
              }
            });
          } else if (!entry.isIntersecting || entry.intersectionRatio < 0.3) {
            // 当banner大部分离开视口时（低于30%可见）
            if (isPlaying) {
              isPlaying = false;
              
              currentVideos.forEach(video => {
                // 暂停视频
                video.pause();
                // 重置播放进度
                video.currentTime = 0;
              });
              
              // 重置内容透明度
              if (bannerContent && !disableContentFade) {
                bannerContent.classList.remove('fade-out');
                bannerContent.style.transition = 'opacity 0.5s ease-in';
                bannerContent.style.opacity = '1';
              }
            }
          }
        });
      }, {
        // 配置多个阈值，用于监测不同的可见比例
        threshold: [0, 0.3, 0.6, 1.0]
      });
      
      // 开始观察banner
      videoObserver.observe(banner);
    }
    
    // 窗口大小改变时重新计算高度
    if (!useAutoHeight) {
      window.addEventListener('resize', setBannerHeight);
    }
    
    // 图片懒加载优化
    const images = banner.querySelectorAll('img');
    images.forEach(img => {
      if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              img.src = img.dataset.src || img.src;
              img.classList.remove('lazy');
              imageObserver.unobserve(img);
            }
          });
        });
        
        imageObserver.observe(img);
      }
    });
    
    // 按钮点击动画增强和锚点跳转处理
    const buttons = banner.querySelectorAll('.mt-hero-banner__button');
    const contentUrl = banner.querySelector('.mt-hero-banner__content-url');
    
    // 处理锚点跳转的平滑滚动
    function handleAnchorClick(e, href) {
      if (href && href.startsWith('#')) {
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          e.preventDefault();
          e.stopPropagation();
          
          // 计算目标位置（考虑固定头部等偏移）
          const headerOffset = 0; // 可以根据实际固定头部高度调整
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          
          // 平滑滚动到目标位置
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
          
          return true;
        }
      }
      return false;
    }
    
    // 为所有按钮添加点击处理
    buttons.forEach(button => {
      button.addEventListener('click', function(e) {
        const href = button.getAttribute('href');
        
        // 如果是锚点链接，处理平滑滚动
        if (handleAnchorClick(e, href)) {
          // 锚点跳转已处理，继续执行动画效果
        }
        
        // 创建点击波纹效果
        const ripple = document.createElement('span');
        const rect = button.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;
        
        ripple.style.cssText = `
          position: absolute;
          width: ${size}px;
          height: ${size}px;
          left: ${x}px;
          top: ${y}px;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          transform: scale(0);
          animation: ripple 0.6s linear;
          pointer-events: none;
        `;
        
        button.appendChild(ripple);
        
        // 动画结束后移除波纹元素
        setTimeout(() => {
          ripple.remove();
        }, 600);
      });
    });
    
    // 为覆盖链接也添加锚点跳转处理
    if (contentUrl) {
      contentUrl.addEventListener('click', function(e) {
        const href = contentUrl.getAttribute('href');
        handleAnchorClick(e, href);
      });
    }
  });
});

// 添加波纹动画CSS
const style = document.createElement('style');
style.textContent = `
  
`;
document.head.appendChild(style);

// 性能优化：节流函数
function throttle(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  }
}

// 优化resize事件
const optimizedResize = throttle(() => {
  const heroBanners = document.querySelectorAll('.mt-hero-banner');
  heroBanners.forEach(banner => {
    const event = new Event('resize');
    banner.dispatchEvent(event);
  });
}, 100);

window.addEventListener('resize', optimizedResize);